"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZComboBox = void 0;
const React = __importStar(require("react"));
const kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
const LocalizedComponent_1 = require("../../languages/LocalizedComponent");
const __1 = require("../");
const styled_components_1 = __importDefault(require("styled-components"));
class ZComboBoxComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focused: false,
            value: props.value || props.defaultValue
        };
        this.boundOnFocusHandler = this.onFocusHandler.bind(this);
        this.boundOnBlurHandler = this.onBlurHandler.bind(this);
        this.boundOnChangeHandler = this.onChangeHandler.bind(this);
        this.componentRef = React.createRef();
    }
    componentDidMount() {
        const comboBox = this.componentRef && this.componentRef.current;
        const field = comboBox &&
            comboBox.element &&
            comboBox.element.firstChild &&
            comboBox.element.firstChild &&
            comboBox.element.firstChild.firstChild;
        if (field) {
            field.addEventListener("click", event => {
                if (comboBox) {
                    comboBox.setState({
                        opened: !comboBox.state.opened
                    });
                }
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }
    render() {
        const { required, className, ...otherProps } = this.props;
        return (React.createElement(__1.RequiredDot, { required: required, raised: this.state.focused ||
                !!this.props.value ||
                (this.props.value === undefined && !!this.state.value), loweredTransform: "down-24 left-2", raisedTransform: "down-8 right-3" },
            React.createElement("span", { className: [className, "z-component z-combobox"].join(" "), id: this.props.id },
                React.createElement(LocalizedComponent_1.LocalizedComponent, Object.assign({}, otherProps),
                    React.createElement(kendo_react_dropdowns_1.ComboBox, Object.assign({}, this.props, { onFocus: this.boundOnFocusHandler, onBlur: this.boundOnBlurHandler, onChange: this.boundOnChangeHandler, ref: this.componentRef, className: this.props.disabled ? "disabled" : undefined }))))));
    }
    onFocusHandler(event) {
        this.setState({ focused: true });
        this.props.onFocus && this.props.onFocus(event);
    }
    onBlurHandler(event) {
        this.setState({
            focused: false,
            value: event.target.value
        }, () => {
            this.props.onBlur && this.props.onBlur(event);
        });
    }
    onChangeHandler(event) {
        this.setState({
            value: event.target.value
        }, () => {
            this.props.onChange && this.props.onChange(event);
        });
    }
    setValue(value) {
        this.setState({
            value
        }, () => {
            this.props.onChange &&
                this.props.onChange({
                    target: { value }
                }, value, false);
        });
    }
}
ZComboBoxComponent.defaultProps = {
    required: false,
    defaultValue: null
};
exports.ZComboBox = styled_components_1.default(ZComboBoxComponent) `
   color: ${props => props.theme["input-color"]};
   & .k-combobox .k-dropdown-wrap .k-input,
   & .k-label {
      margin: 0px 3px 1px 5px;
      font-family: ${props => props.theme["font-family"]};
   }
   & .k-combobox:hover {
      background: ${props => props.disabled ? null : props.theme["input-background-hover-color"]};
   }
   & .k-combobox-clearable .k-icon.k-clear-value.k-i-close {
      position: absolute;
      right: 18px;
   }
   & .k-textbox-container {
      width: ${props => (props.width ? `${props.width}px` : "200px")};
   }
   margin: 10px;
   display: inline-block;
`;
//# sourceMappingURL=ZComboBox.js.map